export const deviceSystemAgeOptions = [
  {
    label: "Less than 3 years",
    value: "o1",
    end: "2",
  },
  {
    label: "More than 3 years",
    value: "o2",
    start: "3",
  },
  {
    label: "More than 5 years",
    value: "o3",
    start: "5",
  },
  {
    label: "More than 8 years",
    value: "o4",
    start: "8",
  },
  {
    label: "More than 8 & Less than 10 years",
    value: "o5",
    start: "8",
    end: "9",
  },
  {
    label: "More than 10 years",
    value: "o6",
    start: "10",
  },
  {
    label: "More than 10 & Less than 15 years",
    value: "o7",
    start: "10",
    end: "14",
  },
  {
    label: "More than 15 years",
    value: "o8",
    start: "15",
  },
  {
    label: "More than 15 & Less than 20 years",
    value: "o9",
    start: "15",
    end: "19",
  },
  {
    label: "More than 20 years",
    value: "o10",
    start: "20",
  },
]
